import {ConversationSummary, OptOutPayload} from "@/components/communications/CommunicationInterfaces";
import {ActionPayload, ReadActionPayload} from "@/components/communications/cards/actions/Actions";
import {httpPost, httpPut} from "@/services/HttpService";

export function getConversationSummaries(body: any): Promise<ConversationSummary[]> {
  return httpPost(`/communications/conversations/search`, body) as any;
}

export async function conversationRead(payload: ReadActionPayload): Promise<void> {
  await httpPut('/communications/read', payload);
}

export async function conversationClosed(payload: ActionPayload): Promise<void> {
  await httpPut('/communications/close', payload);
}

export async function conversationOptedOut(payload: OptOutPayload): Promise<void> {
  await httpPut('/communications/opted-out', payload);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/communications/services/CommunicationService.ts